import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DevExtremeModule} from '../devextreme.module';
import {HorizontalSkewTrayIndicatorComponent} from './horizontal-skew-tray-indicator.component';
import {HorizontalSkewChartPopupComponent} from './horizontal-skew-chart-popup.component';
import {HorizontalSkewPanelIndicatorComponent} from './horizontal-skew-panel-indicator.component';
import {HorizontalSkewService} from './horizontal-skew.service';

@NgModule({
    imports: [
        CommonModule,
        DevExtremeModule,
    ],
    exports: [
        HorizontalSkewTrayIndicatorComponent,
        HorizontalSkewChartPopupComponent,
        HorizontalSkewPanelIndicatorComponent
    ],
    declarations: [
        HorizontalSkewTrayIndicatorComponent,
        HorizontalSkewChartPopupComponent,
        HorizontalSkewPanelIndicatorComponent
    ],
    providers: [
        HorizontalSkewService
    ]
})
export class HorizontalSkewModule {
}
